import React, { Component } from "react";
import PropTypes from "prop-types";
import { connectStats } from "react-instantsearch-dom";

import ProductCategory from "~/scripts/components/products/ProductCategory";
import Applications from "~/scripts/components/products/Applications";
import LumenOutput from "~/scripts/components/products/LumenOutput";
import Brands from "~/scripts/components/products/Brands";
import IPRating from "~/scripts/components/products/IPRating";
import AlgoliaCredit from "~/scripts/components/products/AlgoliaCredit";

class Filters extends Component {
    static propTypes = {
        nbHits: PropTypes.number.isRequired
    };

    state = {
        active: false
    };

    handleClick = () => {
        this.setState({ active: !this.state.active });
    };

    render() {
        const { nbHits } = this.props;
        const { active } = this.state;

        return (
            <div className={`filters ${active ? "is-filters-active" : ""}`}>
                <h4 className="filters__title" onClick={this.handleClick}>
                    Filter products <span>({nbHits})</span>
                </h4>
                <div className="filters__body">
                    <div className="filters__section">
                        <div className="filters__section-title">Categories</div>
                        <ProductCategory />
                    </div>
                    <div className="filters__section">
                        <div className="filters__section-title">Filters</div>
                        <Applications />
                        <LumenOutput />
                        <Brands />
                        <IPRating />
                    </div>

                    {window.__ENV_DATA__.ENV !== "production" && (
                        <div className="filters__section">
                            <AlgoliaCredit />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default connectStats(Filters);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Filters.js